module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2afe9c81ed327ae2f01daf5367a465ff.gif";